import { AnimatePresence, motion } from 'framer-motion';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/app/StoreContext';
import { humanizeReason } from '@/domain/rejectReason';
import styles from './ScoreFlash.module.css';

export const ScoreFlash = observer(function ScoreFlash() {
  const { ui } = useStore();
  return (
    <div className={styles.wrapper} aria-live="polite" aria-atomic="true">
      {ui.flashState?.kind === 'accepted' && (
        <div key={ui.flashState.id} className={`${styles.flash} ${styles.accepted}`}>
          +{ui.flashState.score}
        </div>
      )}
      <AnimatePresence>
        {ui.flashState?.kind === 'rejected' && (
          <motion.div
            key={ui.flashState.id}
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.18 }}
            className={`${styles.flash} ${styles.rejected}`}
          >
            {ui.flashState.reason
              ? humanizeReason(ui.flashState.reason)
              : 'Отказано'}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
});
